<template>
  <div v-if="show" class="simple-pagination">
    <vue-awesome-paginate v-model="currentPage"
                          :total-items="records"
                          :items-per-page="perPage"
                          :max-pages-shown="chunkNumber"
                          :show-breakpoint-buttons="false"
                          :show-ending-buttons="false"
                          :show-jump-buttons="false"
                          :hide-prev-next-when-ends="true"
                          :locale="i18n.locale()"
                          :dir="textDirection"
                          :class="`pagination theme-${theme}`"
                          paginate-buttons-class="page-link"
                          @click="onPaginate" />
  </div>
  <div v-else />
</template>

<script>
import { VueAwesomePaginate } from 'vue-awesome-paginate'
import 'vue-awesome-paginate/dist/style.css'

export default {
  components: { VueAwesomePaginate },
  props: {
    initialPage: {
      type: Number,
      required: false
    },
    perPage: {
      // We name prop `perPage` instead of `per-page` so it can be passed to child too.
      type: Number,
      required: true
    },
    records: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: false,
      default: 1 // Default for the time period when no data has yet been fetched
    },
    chunkNumber: {
      type: Number,
      required: false,
      default: 10
    },
    theme: {
      type: String,
      default: 'org'
    }
  },

  emits: ['paginate'],

  data() {
    return {
      currentPage: this.initialPage || 1
    }
  },

  computed: {
    show() {
      return this.totalPages > 1 && this.currentPage <= this.totalPages
    },

    textDirection() {
      return this.i18n.isRtl() ? 'rtl' : 'ltr'
    }
  },

  watch: {
    initialPage() {
      this.currentPage = this.initialPage
    }
  },

  methods: {
    onPaginate: function(page) {
      this.$emit('paginate', page)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

.simple-pagination {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ::v-deep(ul.pagination-container) {
    display: flex;
    flex-wrap: wrap;

    .page-link {
      background-color: transparent;
    }
    $theme-colors: ("org": colors.$dark-blue, "public": colors.$black);

    @each $theme, $color in $theme-colors {
      &.theme-#{$theme} {
        .page-link {
          color: $color;
        }

        .page-link.active-page {
          background-color: $color;
          border-color: $color;
          color: white;
        }
      }
    }
  }
}
</style>
